import { StripeCardElementOptions } from "@stripe/stripe-js";
import cardOptions from "./cardOptions";

type CardElementPalette = {
  primary: { main: string };
  contrastText: { main: string };
  placeholder: { main: string };
};

type Params = {
  palette: CardElementPalette;
  isDark: boolean;
  disabled: boolean;
};

// Stripe renders the card field in an iframe, so page CSS can't reach it:
// the placeholder colour must be passed through the element's own style.
export const getCardElementOptions = ({
  palette,
  isDark,
  disabled,
}: Params): StripeCardElementOptions => ({
  ...cardOptions,
  style: {
    base: {
      iconColor: palette.primary.main,
      color: palette.contrastText.main,
      ...(isDark && { "::placeholder": { color: palette.placeholder.main } }),
    },
  },
  disabled,
});
